import {MFA_TYPE, MINIMUM_ATTEMPTS} from "../constants";
import {BackupCodeButton} from "./backupCodeButton";
import React, {useState} from "react";
import {sendCode} from "../../actions/authActions";
import {segToHours} from "../../utils/date";
import {Button} from "semantic-ui-react";
import {CustomContainer, CustomDivider} from "../../components/custom-common";

export const PreviewEmailToVerified = ({ mfaToken, userName, mfaEmailSetUpped, handleCheckPreview, handleUseMethod }) => {

  const [hasReachedMaxCodeRequest, setHasReachedMaxCodeRequest] = useState(false)
  const [remainingLockedOutTimeWindowSeconds, setRemainingLockedOutTimeWindowSeconds] = useState(null);

  const sendCodeByEmailHandler = async () => {
    try {
      const {data} = await sendCode(userName, MFA_TYPE.EMAIL, mfaToken)
      const hasReachedMaxCode = data.remainingSendCodeAttempts === MINIMUM_ATTEMPTS
      setHasReachedMaxCodeRequest(hasReachedMaxCode)
      setRemainingLockedOutTimeWindowSeconds(data.remainingLockedOutTimeWindowSeconds)
      if (!hasReachedMaxCode) handleCheckPreview()
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <>
      <div className={"small neutral700Text"}>
        You provided {mfaEmailSetUpped} email address for two-factor authentication.
        Click Send code to receive an email containing a 6-digit code—
      </div>
      <CustomDivider small hidden/>
      <Button fluid primary
        onClick={sendCodeByEmailHandler}
        disabled={hasReachedMaxCodeRequest}
      >
        Send code
      </Button>
      <CustomDivider small hidden/>

      {hasReachedMaxCodeRequest && (
          <CustomContainer basic className={'mfaMaxRequestsWarning'}>
          <strong>You have reached the maximum number of code requests. </strong>
          Please try again in {segToHours(remainingLockedOutTimeWindowSeconds)} hours or try a different authentication method.
          </CustomContainer>
      )}

      <BackupCodeButton handleUseMethod={() => handleUseMethod(MFA_TYPE.BACKUP_CODES)} />
    </>
  )
}
